// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M21,9.5C21,8.7,20.3,8,19.5,8H17V3H7v5H4.5C3.7,8,3,8.7,3,9.5V16h2v3h2v2h10v-2h2v-3h2V9.5z M8,4h8v4H8V4z M6,18v-4h1v4H6z
		 M16,20H8v-6h8V20z M18,18h-1v-4h1V18z M20,15h-1v-2H5v2H4V9.5C4,9.2,4.2,9,4.5,9h15C19.8,9,20,9.2,20,9.5V15z M6,11h4v1H6V11z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-print-BvyiWATf.js.map
